$(document).ready(function () {
    if (document.querySelector('.researchers-contact-us-form') === null) {
        return;
    }

    researchersUsageChange(".researchers-contact-us-form");

    $('.researchers-contact-us-form').on('submit', function (event) {
        let form = $(event.target);
        let fullName = form.find('[name=full-name]').val(),
            organisationName = form.find('[name=organisation-name]').val(),
            jobTitle = form.find('[name=jobTitle]').val(),
            email = form.find('[name=email]').val(),
            phone = form.find('[name=phone]').val(),
            usage = form.find('[name=usageValue]').val(),
            message = form.find('[name=message]').val();

        if (!$('.invalid-feedback').is(':visible')) {
            $.ajax({
                url: $('#ajax_url').val(),
                type: "POST",
                cache: false,
                data: {
                    action: 'researchers_bottom_form',
                    fullName: fullName,
                    organisationName: organisationName,
                    jobTitle: jobTitle,
                    email: email,
                    phone: phone,
                    usage: usage,
                    message: message,
                },
                success: function (res) {
                    successSend(res);
                }
            });
        }

        return false;
    });

    function researchersUsageChange(selector) {
        let contactFormUsageElements = $(document).find(`${selector} .usage-list span`);
        let usageElementValue = $(document).find(`${selector} .usageValue`);
        let activeValues = [];

        contactFormUsageElements.click(function (event) {
            let element = event.target;

            contactFormUsageElements.each(function () {
                this.classList.remove('active');
            });

            activeValues = this.dataset.value;
            element.classList.toggle('active')

            usageElementValue.attr('value', activeValues);
        });
    }
});

